import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class QuestionnaireEmployee  {
    _originalTypeClassName = "zERP.BO.QuestionnaireEmployee";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
QuestionnaireEmployee.translate = translateService;
}
this.lstQuestionnaireValue = [];
this.Id = null;
this.EffectiveFrom = null;
this.EffectiveTo = null;
this.Comments = null;
this.State = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
EffectiveFrom:any;
EffectiveTo:any;
Comments:any;
State:any;
EmployeeContract:any;
lstQuestionnaireValue:any;
QuestionnaireType:any;
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setlstQuestionnaireValue = ($this, items) => {
                if (items == null) items = [];
                if ($this.lstQuestionnaireValue == null) $this.lstQuestionnaireValue = [];

                const copyItems = Common.cloneObject(items);

                while ($this.lstQuestionnaireValue.length > 0) {
                    Domain.QuestionnaireEmployee.removelstQuestionnaireValue($this, $this.lstQuestionnaireValue[0]);
                }

                Domain.QuestionnaireEmployee.addManylstQuestionnaireValue($this, copyItems);
            }
static addManylstQuestionnaireValue = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.QuestionnaireEmployee.addlstQuestionnaireValue($this, items[i]);
                }
            }
static addlstQuestionnaireValue = ($this, item) => {
                if ($this.lstQuestionnaireValue == null) $this.lstQuestionnaireValue = [];
                if (item == null || $this.lstQuestionnaireValue.indexOf(item) > -1) return;
                $this.lstQuestionnaireValue.push(item);
}
static addRangelstQuestionnaireValue = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.QuestionnaireEmployee.addlstQuestionnaireValue($this, item));
            }
static removelstQuestionnaireValue = ($this, item) => {
                if ($this == null || $this.lstQuestionnaireValue == null || $this.lstQuestionnaireValue.indexOf(item) === -1) return;
                var _index = $this.lstQuestionnaireValue.indexOf(item);
                $this.lstQuestionnaireValue.splice(_index, 1);
}
static clearlstQuestionnaireValue = ($this) => { $this.lstQuestionnaireValue = null; }
static setQuestionnaireType = ($this, value) => {
var oldValue = $this.QuestionnaireType;
$this.QuestionnaireType = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}